<template>
    <rkm-layout-body title="Lista de paciente">
        <template v-slot:actions>
            <rkm-button
                v-if="form.isPermissaoCadastro"
                @click="$router.push({ name: 'cadastro-paciente-create' })"
                color="primary"
                authorize="store-cadastro-paciente"
            >
                Cadastrar paciente
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List :form="form"/>
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/paciente/List'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, stringCase, object, certificadoDigital } from '@/mixins'

export default {
    components: { List },
    mixins: [ repository, error, stringCase, object, certificadoDigital ],
    created() {

        this.repositories.paciente = this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente')

        this.load()
    },
    data: () => ({
        repositories: {
            paciente: null,
        },
        additionals: null,
        form: {
            isPermissaoCadastro: null,
            isPermissaoEndereco: null,
            isPermissaoBloquear: null,
            isNotParametrizado: null,
            classificacoes: [],
        },
        loaded: false,
    }),
    methods: {
    ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.paciente.list()
                .then(({ data }) => this.setData(data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData({ additionals, form }) {

            this.additionals = additionals

            this.form.isPermissaoCadastro = form.classificacoes.length > 0 || form.isPermissaoCadastro ? true : false
            this.form.isNotParametrizado = form.isPermissaoCadastro ? true : false
            this.form.classificacoes = form.classificacoes
            this.form.isPermissaoEndereco = form.isPermissaoEndereco
            this.form.isPermissaoBloquear = form.isPermissaoBloquear
            this.loaded = true

            this.exibirAvisoValidadeCertificadoDigital(this.additionals.dadosCertificadoDigital)
        },
    }
}
</script>